import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext.jsx';

/**
 * 後台受保護路由：除了要登入，user.role 還必須是 admin。
 *
 * 行為：
 *   - 未登入 → 跳 /login（夾帶 from，登入後可跳回）
 *   - 已登入但非 admin → 跳首頁（也可改 403 頁）
 *   - admin → 渲染 children
 */
function AdminRoute({ children }) {
  const { isAuthenticated, isAdmin, isInitializing } = useAuth();
  const location = useLocation();

  if (isInitializing) return null;

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }
  return children;
}

export default AdminRoute;
